import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from "react";
import PropTypes from "prop-types";
import { getClassNameFactory } from "../../../../utilities";
import List from "../../../List";
import Modal from "../../../../modules/Modal";
import { Button } from "../../../../elements";
import { ButtonKind, IconPosition } from "../../../../elements/Button";
import InfoIcon from "../InfoIcon";
import OpenInNewTab2 from "@dcl/icons/esm/ui/open-in-new-tab-2";

var FeatureCell = function FeatureCell(_ref) {
  var name = _ref.name,
      listOptions = _ref.listOptions,
      modal = _ref.modal;
  var getClassName = getClassNameFactory(FeatureCell.displayName);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      openModal = _useState2[0],
      setOpenModal = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      modalData = _useState4[0],
      setModalData = _useState4[1];

  var handlePressOkBtn = function handlePressOkBtn() {
    setOpenModal(false);

    if (modalData !== null && modalData !== void 0 && modalData.onPressOkBtn) {
      modalData.onPressOkBtn();
    }
  };

  var handlePressCancelBtn = function handlePressCancelBtn() {
    setOpenModal(false);

    if (modalData !== null && modalData !== void 0 && modalData.onPressCancelBtn) {
      modalData.onPressCancelBtn();
    }
  };

  var handleOpenModal = function handleOpenModal(modalInfo) {
    setModalData(modalInfo);
    setOpenModal(true);
  };

  var onCloseModal = function onCloseModal() {
    setOpenModal(false);

    if (modalData !== null && modalData !== void 0 && modalData.onClose) {
      modalData.onClose();
    }
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(getClassName(), " ").concat((listOptions === null || listOptions === void 0 ? void 0 : listOptions.length) > 0 ? getClassName({
      descendantName: "featureName"
    }) : "")
  }, listOptions !== null && listOptions !== void 0 && listOptions.length ? /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "name"
    })
  }, name) : /*#__PURE__*/React.createElement(Button, {
    kind: ButtonKind.BUTTON,
    onClick: function onClick() {
      return handleOpenModal(modal);
    },
    icon: /*#__PURE__*/React.createElement(InfoIcon, null),
    iconPosition: IconPosition.RIGHT,
    "aria-label": name,
    "aria-expanded": openModal
  }, name), (listOptions === null || listOptions === void 0 ? void 0 : listOptions.length) > 0 && /*#__PURE__*/React.createElement(List, null, listOptions.map(function (item) {
    return /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Button, {
      kind: ButtonKind.BUTTON,
      onClick: function onClick() {
        return handleOpenModal(item.modal);
      },
      "aria-label": item.text
    }, item.text));
  })), openModal && modalData && /*#__PURE__*/React.createElement(Modal, {
    closeLabel: "",
    headerId: modalData === null || modalData === void 0 ? void 0 : modalData.title,
    headerTitle: modalData === null || modalData === void 0 ? void 0 : modalData.title,
    className: getClassName({
      descendantName: "modal"
    }),
    closeThisComponent: onCloseModal,
    isCloseButtonHidden: modalData === null || modalData === void 0 ? void 0 : modalData.isCloseButtonHidden,
    disableScrollLocked: !(modalData !== null && modalData !== void 0 && modalData.disableScrollLocked)
  }, (modalData === null || modalData === void 0 ? void 0 : modalData.subTitle) && /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "subtitle"
    })
  }, modalData === null || modalData === void 0 ? void 0 : modalData.subTitle), /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "content"
    })
  }, modalData === null || modalData === void 0 ? void 0 : modalData.content), ((modalData === null || modalData === void 0 ? void 0 : modalData.cancelBtnLabel) || (modalData === null || modalData === void 0 ? void 0 : modalData.okBtnLabel)) && /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "modal-footer"
    })
  }, (modalData === null || modalData === void 0 ? void 0 : modalData.cancelBtnLabel) && /*#__PURE__*/React.createElement("a", {
    href: modalData.cancelBtnLink,
    target: modalData.cancelBtnTarget,
    "aria-label": modalData.cancelBtnAriaLabel,
    className: getClassName({
      descendantName: "modal-secondary-link"
    }),
    onClick: handlePressCancelBtn,
    tabIndex: 0
  }, /*#__PURE__*/React.createElement(Button, {
    color: "secondary",
    kind: ButtonKind.BUTTON,
    tabIndex: -1
  }, /*#__PURE__*/React.createElement("span", null, modalData === null || modalData === void 0 ? void 0 : modalData.cancelBtnLabel, (modalData === null || modalData === void 0 ? void 0 : modalData.cancelBtnTarget) && modalData.cancelBtnTarget === "_blank" && /*#__PURE__*/React.createElement(OpenInNewTab2, {
    size: 16
  })))), (modalData === null || modalData === void 0 ? void 0 : modalData.okBtnLabel) && /*#__PURE__*/React.createElement("a", {
    href: modalData.okBtnLink,
    target: modalData.okBtnTarget,
    "aria-label": modalData.okBtnAriaLabel,
    className: getClassName({
      descendantName: "modal-primary-link"
    }),
    onClick: handlePressOkBtn,
    tabIndex: 0
  }, /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    kind: ButtonKind.BUTTON,
    tabIndex: -1
  }, /*#__PURE__*/React.createElement("span", null, modalData === null || modalData === void 0 ? void 0 : modalData.okBtnLabel, (modalData === null || modalData === void 0 ? void 0 : modalData.okBtnTarget) && modalData.okBtnTarget === "_blank" && /*#__PURE__*/React.createElement(OpenInNewTab2, {
    size: 16
  })))))));
};

FeatureCell.displayName = "PlanComparisonTable.FeatureCell";
FeatureCell.propTypes = {
  name: PropTypes.string,
  listOptions: PropTypes.arrayOf(PropTypes.shape({
    href: PropTypes.string,
    text: PropTypes.string
  })),
  showInfoIcon: PropTypes.bool,
  modal: PropTypes.shape({
    title: PropTypes.string,
    subTitle: PropTypes.string,
    content: PropTypes.string,
    okBtnLabel: PropTypes.string,
    okBtnLink: PropTypes.string,
    okBtnTarget: PropTypes.string,
    okBtnAriaLabel: PropTypes.string,
    cancelBtnLabel: PropTypes.string,
    cancelBtnLink: PropTypes.string,
    cancelBtnTarget: PropTypes.string,
    cancelBtnAriaLabel: PropTypes.string,
    isCloseButtonHidden: PropTypes.bool,
    onPressOkBtn: PropTypes.func,
    onPressCancelBtn: PropTypes.func,
    onClose: PropTypes.func
  })
};
export default FeatureCell;